import React, {useState, useEffect, useRef} from "react";
import * as StompJs from '@stomp/stompjs';
import { Layout, Dropdown, Menu, Avatar, Badge } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownOutlined,
  UserOutlined,
  BellOutlined
} from "@ant-design/icons";
import * as Icon from "react-feather";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import notifyUtitls from '../../utils/notify-utils';
import StorageUtils from '../../utils/storage-session-utils';
import authenAction from "../../redux/action/authen-action";
import chatService from "../../services/chat-service";
import chatAction from '../../redux/action/chat-action';
import { useHistory } from 'react-router-dom';
import { chatConnectStatus } from "../../constants/app-constants";
import { APP_CUSTOM_API } from '../../config/app-config';

// const { Header } = Layout;

const Header = ({ collapsed, toggle }) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const userInfo = useSelector(state => state.authenReducer.userInfo);

  const [noti, setNoti] = useState(null);
  const [notiStatus, setNotiStatus] = useState(chatConnectStatus.NONE);
  const notiClient = useRef(null);

  const countMessage = useSelector(
    (state) => state.chatReducer.countMessage
  );

  useEffect(() => {
    const client = new StompJs.Client({
      brokerURL: APP_CUSTOM_API.ADMIN_WSK,
      forceBinaryWSFrames: true,
      appendMissingNULLonIncoming: true,
   
      onConnect: () => {
        setNotiStatus(chatConnectStatus.CONNECTED);
      },

      onWebSocketError: (err)=>{
        notiClient.current?.deactivate();
      },

      onDisconnect: () => {
        console.log('onDisconnect');
        setNotiStatus(chatConnectStatus.DISCONNECTED);
        notiClient.current?.deactivate();
      },

      onStompError: (frame) => {
        notiClient.current?.deactivate();
      },
    });

    notiClient.current = client;
  }, []);

  useEffect(() => {
    if(chatConnectStatus.NONE === notiStatus && notiClient){
      notiClient.current.activate();
    }

    if (chatConnectStatus.CONNECTED === notiStatus && notiClient) {
      notiClient.current.subscribe("/topic/admin/noti", (message) => {
        doCountReadable();
      });
    }
    
  }, [notiStatus, notiClient]);

  useEffect(() => {
    doCountReadable();
  }, [countMessage]);

  const doCountReadable = async () => {
    try {
      let result = await chatService.countReadable();
      await dispatch(chatAction.countReadable(result))

      setNoti(result.message);
    } catch (err) {
      //console.log('err', err);
      //dispatch(notifyUtitls.error(err));
      notifyUtitls.error(err);
    }
  };

  const logout = ()=>{
    StorageUtils.removeToken();
    dispatch(authenAction.signOut());
  }

  const chatHandler = () => {
    history.replace('/live-chat');
  }
  
  const menu = (
    <Menu>
      <Menu.Item>
        <span target="_blank" rel="noopener noreferrer">
          <Icon.User size='14' className="transform-nmu me-1 color-primary" /> 
          <Link to="/profile">Profile</Link>
        </span>
      </Menu.Item>
      <Menu.Item>
        <span target="_blank" rel="noopener noreferrer">
          <Icon.LogOut size='14' className="transform-nmu me-1 color-primary" />
          <Link to="/" onClick={logout}>Logout</Link>
        </span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout.Header className="site-layout-background">
      {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
        className: "trigger",
        onClick: toggle,
      })}
      <div className="ms-auto">

        {userInfo.userRole !== 'CM' ? 
            <span style={{ marginRight: '20px' }} >
              <Badge count={noti}>
                <BellOutlined 
                  style={{
                    marginRight: '15px',
                    fontSize: '15px'
                  }}
                  onClick={chatHandler} 
                />
              </Badge>
            </span>
          : null}
        
        <Dropdown overlay={menu}>
          <span
            className="ant-dropdown-link"
            onClick={(e) => e.preventDefault()}
          >
            <Avatar
              className="me-2 "
              style={{ backgroundColor: '#F2F2F2' }}
              size="30"
              icon={
                <UserOutlined
                  className="color-primary"
                  style={{ transform: "translateY(-5px)" }}
                />
              }
            />
            {userInfo.username} <DownOutlined className=" transform-nmu" />
          </span>
        </Dropdown>
      </div>
    </Layout.Header>
  );
};

export default Header;
